import { useAuth } from "src/providers/AuthProvider";
import PaylinqLogo from "src/images/paylinq-logo.png";
import { ProSidebarProvider } from "react-pro-sidebar";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import PageHeader from "src/layouts/ProtectedRoute/PageHeader";
import { Suspense, useState } from "react";
import styled from "styled-components";
import DashboardContext from "src/context/DashboardContext";
import CustomModal from "src/components/CustomModal";
import UpdatePassword from "src/components/modals/UpdatePassword";

const PageLoader = () => {
	return (
		<div className="page_loading">
			<img src={PaylinqLogo} alt="Loading" />
			<br />
			<p>Loading...</p>
		</div>
	);
};

const ProtectedRoute = () => {
	const { pathname } = useLocation();
	const { isAuthenticated, user } = useAuth();

	const [isDefaultPassword, setIsDefaultPassword] = useState(user?.has_default_password);

	if (!user?.has_default_password && !user?.bvn_verified && pathname !== "/account") return <Navigate to="/account" />;

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<ProSidebarProvider>
			<DashboardContext>
				<Container>
					<Sidebar />
					<div className="tw-flex tw-flex-col wrapper">
						<PageHeader user={user} />
						<main className="tw-flex-grow tw-px-6 tw-py-8 tw-bg-base md:tw-px-10">
							<Suspense fallback={<PageLoader />}>
								<Outlet />
								<CustomModal title="Update Default Password" open={isDefaultPassword} onOpenChange={setIsDefaultPassword}>
									<UpdatePassword isForDefault />
								</CustomModal>
							</Suspense>
						</main>
					</div>
				</Container>
			</DashboardContext>
		</ProSidebarProvider>
	);
};

const Container = styled.div`
	display: flex;
	overflow: hidden;

	.wrapper {
		max-height: 100dvh;
		min-height: 100dvh;
		flex: 1;
		width: calc(100% - 250px);
		background-color: #f6f7f8;
		overflow-y: scroll;

		& > div {
			padding-left: 1.5rem;
			padding-right: 1.5rem;
		}
	}

	@media only screen and (max-width: 900px) {
		.wrapper {
			min-height: 100dvh;
			flex: 1;
			width: 100%;

			& > div {
				padding-left: 1rem;
				padding-right: 1rem;
			}
		}
	}
`;

export default ProtectedRoute;
